(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[147],{

/***/ 15885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CardCarousel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: external "React"
var external_React_ = __webpack_require__(37667);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Icons/index.ts + 24 modules
var Icons = __webpack_require__(56693);
// EXTERNAL MODULE: ./src/components/CloudflareResizedImage/index.ts + 1 modules
var CloudflareResizedImage = __webpack_require__(90225);
// EXTERNAL MODULE: ./src/components/CardCarousel/CardCarousel.module.scss
var CardCarousel_module = __webpack_require__(23896);
var CardCarousel_module_default = /*#__PURE__*/__webpack_require__.n(CardCarousel_module);
;// CONCATENATED MODULE: ./src/components/CardCarousel/CardCarousel.tsx







var CardCarousel = function(param) {
    var _disableImageLoader = param.disableImageLoader, disableImageLoader = _disableImageLoader === void 0 ? false : _disableImageLoader, _images = param.images, images = _images === void 0 ? [] : _images, imageAlt = param.imageAlt, isReferrer = param.isReferrer, _itemAspectRatio = param.itemAspectRatio, itemAspectRatio = _itemAspectRatio === void 0 ? 0.65 : _itemAspectRatio, link = param.link, linkAs = param.linkAs, segmentEvent = param.segmentEvent, openLinkInNewTab = param.openLinkInNewTab;
    var ref = (0,external_React_.useState)(images[0]), currentImage = ref[0], setCurrentImage = ref[1];
    var carouselRef = (0,external_React_.useRef)(null);
    var navigateImage = function(index) {
        if (index === (images === null || images === void 0 ? void 0 : images.length)) {
            setCurrentImage(images[0]);
            return;
        }
        if (index === -1) {
            setCurrentImage(images === null || images === void 0 ? void 0 : images[images.length - 1]);
            return;
        }
        setCurrentImage(images[index]);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (CardCarousel_module_default()).cardCarousel,
        ref: carouselRef,
        style: {
            // @ts-ignore
            "--sl-card-aspect-ratio": "".concat(itemAspectRatio * 100, "%")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: link || "",
                as: linkAs,
                shallow: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: segmentEvent,
                    target: openLinkInNewTab ? "_blank" : "",
                    referrerPolicy: isReferrer ? "no-referrer-when-downgrade" : "strict-origin-when-cross-origin",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudflareResizedImage/* default */.Z, {
                        disableImageLoader: disableImageLoader,
                        lazyRoot: carouselRef,
                        alt: imageAlt || "Current Card",
                        src: currentImage,
                        loading: "lazy",
                        objectFit: "cover",
                        objectPosition: "center",
                        layout: "fill",
                        style: {
                            aspectRatio: "".concat(itemAspectRatio)
                        },
                        sizes: "(min-width: 769px) 35vw, (max-width: 768px) 66.6vw"
                    })
                })
            }),
            images.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CardCarousel_module_default()).cardCarouselPreviousWrap,
                        style: {
                            left: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            className: (CardCarousel_module_default()).cardCarouselPrevious,
                            type: "button",
                            onClick: function() {
                                return navigateImage(images.indexOf(currentImage) - 1);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronLeft */.s$, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CardCarousel_module_default()).cardCarouselNextWrap,
                        style: {
                            right: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            className: (CardCarousel_module_default()).cardCarouselNext,
                            type: "button",
                            onClick: function() {
                                return navigateImage(images.indexOf(currentImage) + 1);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronRight */._Q, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CardCarousel_module_default()).cardCarouselIndicators,
                        children: images.map(function(__, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "".concat((CardCarousel_module_default()).cardCarouselIndicator, " ").concat(images.indexOf(currentImage) === index ? (CardCarousel_module_default()).cardCarouselIndicatorActive : ""),
                                type: "button",
                                onClick: function() {
                                    return navigateImage(index);
                                },
                                "aria-label": "image ".concat(index, " button")
                            }, "indicator-button-".concat(index + 1));
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CardCarousel_CardCarousel = (CardCarousel);

;// CONCATENATED MODULE: ./src/components/CardCarousel/index.ts

/* harmony default export */ var components_CardCarousel = (CardCarousel_CardCarousel);


/***/ }),

/***/ 43760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ContentCarouselCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: external "React"
var external_React_ = __webpack_require__(37667);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(21023);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardActions/CardActions.js + 1 modules
var CardActions = __webpack_require__(62023);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(42992);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-truncate-markup/es/index.js + 2 modules
var es = __webpack_require__(6732);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/CardCarousel/index.ts + 1 modules
var CardCarousel = __webpack_require__(15885);
// EXTERNAL MODULE: ./src/config/index.ts + 1 modules
var config = __webpack_require__(49230);
// EXTERNAL MODULE: ./src/utils/supplierUtils.ts
var supplierUtils = __webpack_require__(34144);
// EXTERNAL MODULE: ./src/utils/stripHTMLFromText.ts
var stripHTMLFromText = __webpack_require__(32450);
// EXTERNAL MODULE: ./src/components/ContentCarouselCard/ContentCarouselCard.module.scss
var ContentCarouselCard_module = __webpack_require__(79410);
var ContentCarouselCard_module_default = /*#__PURE__*/__webpack_require__.n(ContentCarouselCard_module);
;// CONCATENATED MODULE: ./src/components/ContentCarouselCard/ContentCarouselCard.tsx













var ContentCarouselCard = function(param) {
    var data = param.data, _styles = param.styles, styles = _styles === void 0 ? {} : _styles, trackCardClick = param.trackCardClick, _useSubtitleForAlt = param.useSubtitleForAlt, useSubtitleForAlt = _useSubtitleForAlt === void 0 ? true : _useSubtitleForAlt;
    var desktopWidth = (0,useMediaQuery/* default */.Z)("(min-width:".concat(config/* default.desktopWidth */.Z.desktopWidth, "px)"));
    var desktopXXLWidth = (0,useMediaQuery/* default */.Z)("(min-width:".concat(config/* default.desktopXXLWidth */.Z.desktopXXLWidth, "px)"));
    var smallMobileWidth = (0,useMediaQuery/* default */.Z)("(min-width:".concat(config/* default.smallMobileWidth */.Z.smallMobileWidth, "px)"));
    var router = (0,next_router.useRouter)();
    var lines = 6;
    if (desktopXXLWidth || desktopWidth) {
        lines = 5;
    } else if (smallMobileWidth) {
        lines = 4;
    }
    var carouselAspectRatio = data.carouselAspectRatio, description = data.description, images = data.images, link = data.link, linkAs = data.linkAs, linkText = data.linkText, subtitle = data.subtitle, title = data.title, type = data.type;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        className: classnames_default()((ContentCarouselCard_module_default()).contentCarouselCard, (0,_define_property/* default */.Z)({}, (ContentCarouselCard_module_default()).supplierCard, type)),
        sx: styles,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ContentCarouselCard_module_default()).contentCarouselCardInner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardCarousel/* default */.Z, {
                        imageAlt: useSubtitleForAlt ? subtitle : title,
                        images: images === null || images === void 0 ? void 0 : images.slice(0, 8),
                        itemAspectRatio: carouselAspectRatio,
                        link: link,
                        linkAs: linkAs,
                        segmentEvent: trackCardClick
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                        className: (ContentCarouselCard_module_default()).cardContent,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ContentCarouselCard_module_default()).contentCarouselCardHeaderWrap,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ContentCarouselCard_module_default()).contentCarouselCardHeader,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    className: (ContentCarouselCard_module_default()).contentCarouselCardTitle,
                                                    variant: description ? "title2" : "footnote",
                                                    children: title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (ContentCarouselCard_module_default()).contentCarouselCardSubtitleWrap,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (ContentCarouselCard_module_default()).contentCarouselCardSubtitle,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                            arrow: true,
                                                            placement: "top",
                                                            title: subtitle || "",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                variant: "title3",
                                                                children: subtitle
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    (0,supplierUtils/* getSupplierIcon */.h)(type || "")()
                                ]
                            }),
                            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ContentCarouselCard_module_default()).descriptionWrap,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, {
                                    lines: lines,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body",
                                        color: "text.primary",
                                        children: (0,stripHTMLFromText/* default */.Z)(description)
                                    })
                                })
                            }),
                            linkText && link && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                                className: (ContentCarouselCard_module_default()).contentCarouselCardActions,
                                children: router ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: link,
                                    as: linkAs,
                                    shallow: !!linkAs,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        classes: {
                                            root: (ContentCarouselCard_module_default()).cardPriceButton
                                        },
                                        color: "secondary",
                                        disableFocusRipple: true,
                                        disableRipple: true,
                                        size: "medium",
                                        style: {
                                            textDecoration: "none"
                                        },
                                        variant: "secondary",
                                        onClick: trackCardClick,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "callout2",
                                            children: linkText
                                        })
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    classes: {
                                        root: (ContentCarouselCard_module_default()).cardPriceButton
                                    },
                                    color: "secondary",
                                    disableFocusRipple: true,
                                    disableRipple: true,
                                    onClick: trackCardClick,
                                    href: link,
                                    size: "medium",
                                    style: {
                                        textDecoration: "none"
                                    },
                                    variant: "secondary",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "callout2",
                                        children: linkText
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            router ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: link,
                as: linkAs,
                shallow: !!linkAs,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (ContentCarouselCard_module_default()).cardLink,
                    "aria-label": "View ".concat(title),
                    onClick: trackCardClick
                })
            }) : // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (ContentCarouselCard_module_default()).cardLink,
                "aria-label": "View ".concat(title),
                href: link,
                onClick: trackCardClick
            })
        ]
    });
};
/* harmony default export */ var ContentCarouselCard_ContentCarouselCard = (ContentCarouselCard);

;// CONCATENATED MODULE: ./src/components/ContentCarouselCard/index.ts

/* harmony default export */ var components_ContentCarouselCard = (ContentCarouselCard_ContentCarouselCard);


/***/ }),

/***/ 50147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xi": function() { return /* binding */ formatProductLinks; },
  "OG": function() { return /* binding */ renderArticleAds; },
  "W5": function() { return /* binding */ renderCalendarCinemaEvents; },
  "Yw": function() { return /* binding */ renderCalendarEvents; },
  "cA": function() { return /* binding */ renderCameraEmbeds; },
  "eK": function() { return /* binding */ renderFeaturedVideo; },
  "lN": function() { return /* binding */ renderIgElements; },
  "Ru": function() { return /* binding */ renderJWElements; },
  "CA": function() { return /* binding */ renderProductCarousel; },
  "nK": function() { return /* binding */ renderResizedImages; },
  "BO": function() { return /* binding */ renderSurfNetworkVideo; },
  "b8": function() { return /* binding */ renderTravelCardCarousel; },
  "PR": function() { return /* binding */ renderTwitterElements; },
  "iM": function() { return /* binding */ renderVideoPaywalls; },
  "AV": function() { return /* binding */ renderYoutubeEmbeds; },
  "y2": function() { return /* binding */ replaceWithClickableImage; },
  "y3": function() { return /* binding */ trackArticleLinkClicks; },
  "Iz": function() { return /* binding */ unmountJWElements; }
});

// UNUSED EXPORTS: getSkinPlayer

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: external "React"
var external_React_ = __webpack_require__(37667);
// EXTERNAL MODULE: external "ReactDOM"
var external_ReactDOM_ = __webpack_require__(19481);
var external_ReactDOM_default = /*#__PURE__*/__webpack_require__.n(external_ReactDOM_);
// EXTERNAL MODULE: ./node_modules/react-oembed-container/dist/index.js
var dist = __webpack_require__(57726);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/@surfline/web-common/esm/getWindow.js
var getWindow = __webpack_require__(32257);
// EXTERNAL MODULE: ./node_modules/@surfline/web-common/esm/utils/fetchOembed.js
var fetchOembed = __webpack_require__(36155);
// EXTERNAL MODULE: ./node_modules/@surfline/web-common/esm/segment.js + 2 modules
var segment = __webpack_require__(59075);
// EXTERNAL MODULE: ./node_modules/@surfline/web-common/esm/api/baseFetch.js
var baseFetch = __webpack_require__(49501);
// EXTERNAL MODULE: ./node_modules/@wavetrak/theme/esm/index.js + 28 modules
var esm = __webpack_require__(74872);
// EXTERNAL MODULE: ./node_modules/@mui/material/CssBaseline/CssBaseline.js
var CssBaseline = __webpack_require__(66720);
// EXTERNAL MODULE: ./node_modules/@mui/styled-engine/StyledEngineProvider/StyledEngineProvider.js
var StyledEngineProvider = __webpack_require__(94810);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/ThemeProvider.js + 5 modules
var ThemeProvider = __webpack_require__(22430);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/PremiumCamCTA/PremiumCamCTA.js
var PremiumCamCTA = __webpack_require__(55560);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/CamPlayer/CamPlayer.js + 3 modules
var CamPlayer = __webpack_require__(74022);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/GoogleDFP/GoogleDFP.js + 5 modules
var GoogleDFP = __webpack_require__(2810);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/AddToCalendar/AddToCalendar.js
var AddToCalendar = __webpack_require__(60438);
// EXTERNAL MODULE: ./src/components/ContentCarouselCard/index.ts + 1 modules
var ContentCarouselCard = __webpack_require__(43760);
// EXTERNAL MODULE: ./src/components/ContentCarousel/index.ts + 3 modules
var ContentCarousel = __webpack_require__(20560);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/icons/PremiumTagLarge/PremiumTagLarge.js
var PremiumTagLarge = __webpack_require__(95963);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/Button/Button.js + 1 modules
var Button = __webpack_require__(25874);
// EXTERNAL MODULE: ./src/config/index.ts + 1 modules
var config = __webpack_require__(49230);
;// CONCATENATED MODULE: ./src/components/PremiumVideoCTA/PremiumVideoCTA.tsx





var PremiumVideoCTA = function(param) {
    var onClickVideoPaywall = param.onClickVideoPaywall, onClickSignIn = param.onClickSignIn, imageUrl = param.imageUrl, _videoText = param.videoText, videoText = _videoText === void 0 ? "" : _videoText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sl-premium-video__cta--image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "sl-premium-video-cta__container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            unoptimized: true,
                            loader: function(param) {
                                var src = param.src;
                                return src;
                            },
                            className: "sl-premium-video-cta__image",
                            src: imageUrl,
                            alt: "imageHere"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "sl-premium-video-cta__overlay",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumTagLarge/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "sl-premium-video-cta__text--top",
                                    children: "Premium Members Score Exclusive Video Premieres"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sl-premium-video-cta__text--middle",
                                    children: "Enjoy 600+ ad-free HD surf cams and expert forecast analysis, as well as exclusive access to in-depth coverage of surf news and culture, travel, tips, movies and more."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    onClick: function() {
                                        return onClickVideoPaywall();
                                    },
                                    children: "Start Free Trial"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "sl-premium-video-cta__text--bottom",
                                    children: [
                                        "Already a Surfline Premium subscriber?",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: config/* default.signInUrl */.Z.signInUrl,
                                            onClick: function() {
                                                return onClickSignIn();
                                            },
                                            className: "sl-premium-video-cta__login",
                                            children: "Sign In"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sl-premium-video-cta__caption",
                /* eslint-disable-next-line react/no-danger */ dangerouslySetInnerHTML: {
                    __html: videoText
                }
            })
        ]
    });
};
/* harmony default export */ var PremiumVideoCTA_PremiumVideoCTA = (PremiumVideoCTA);

;// CONCATENATED MODULE: ./src/components/PremiumVideoCTA/index.ts


// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardActions/CardActions.js + 1 modules
var CardActions = __webpack_require__(62023);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button_Button = __webpack_require__(42992);
// EXTERNAL MODULE: ./node_modules/react-truncate-markup/es/index.js + 2 modules
var es = __webpack_require__(6732);
// EXTERNAL MODULE: ./src/components/CardCarousel/index.ts + 1 modules
var CardCarousel = __webpack_require__(15885);
// EXTERNAL MODULE: ./src/components/ProductCard/ProductCard.module.scss
var ProductCard_module = __webpack_require__(87229);
var ProductCard_module_default = /*#__PURE__*/__webpack_require__.n(ProductCard_module);
;// CONCATENATED MODULE: ./src/components/ProductCard/ProductCard.tsx






var ProductCard = function(param) {
    var data = param.data, _styles = param.styles, styles = _styles === void 0 ? {} : _styles, trackCardClick = param.trackCardClick;
    var carouselAspectRatio = data.carouselAspectRatio, category = data.category, categoryLink = data.categoryLink, images = data.images, link = data.link, linkText = data.linkText, title = data.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        className: (ProductCard_module_default()).card,
        sx: styles,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ProductCard_module_default()).cardInner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardCarousel/* default */.Z, {
                        disableImageLoader: true,
                        imageAlt: title,
                        images: images === null || images === void 0 ? void 0 : images.slice(0, 8),
                        itemAspectRatio: carouselAspectRatio,
                        link: link,
                        openLinkInNewTab: true,
                        segmentEvent: trackCardClick,
                        isReferrer: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                        className: (ProductCard_module_default()).cardContent,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ProductCard_module_default()).cardHeader,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: categoryLink,
                                            onClick: trackCardClick,
                                            target: "_blank",
                                            referrerPolicy: "no-referrer-when-downgrade",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                className: (ProductCard_module_default()).cardCategory,
                                                variant: "footnote",
                                                children: category
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: link,
                                            className: (ProductCard_module_default()).cardTitle,
                                            onClick: trackCardClick,
                                            target: "_blank",
                                            referrerPolicy: "no-referrer-when-downgrade",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, {
                                                lines: 2,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "title3",
                                                    children: title
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            linkText && link && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                                className: (ProductCard_module_default()).cardActions,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: link,
                                    target: "_blank",
                                    referrerPolicy: "no-referrer-when-downgrade",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        size: "medium",
                                        style: {
                                            textDecoration: "none"
                                        },
                                        variant: "primary",
                                        onClick: trackCardClick,
                                        children: linkText
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (ProductCard_module_default()).cardLink,
                "aria-label": "View ".concat(title),
                href: link,
                onClick: trackCardClick,
                target: "_blank",
                referrerPolicy: "no-referrer-when-downgrade"
            })
        ]
    });
};
/* harmony default export */ var ProductCard_ProductCard = (ProductCard);

;// CONCATENATED MODULE: ./src/components/ProductCard/index.ts

/* harmony default export */ var components_ProductCard = (ProductCard_ProductCard);

// EXTERNAL MODULE: ./src/utils/adConfig.js + 1 modules
var adConfig = __webpack_require__(9407);
// EXTERNAL MODULE: ./src/utils/transformers.ts
var transformers = __webpack_require__(30466);
// EXTERNAL MODULE: ./src/common/api/spot.ts
var spot = __webpack_require__(18241);
// EXTERNAL MODULE: ./src/common/api/cameras.js
var cameras = __webpack_require__(75829);
// EXTERNAL MODULE: ./src/common/baseFetch.js
var common_baseFetch = __webpack_require__(19990);
;// CONCATENATED MODULE: ./src/utils/renderCustomComponents.js


























var win = (0,getWindow/* default */.Z)();
var swellEventArticleButton = "<div class='sl-swell-event__article__image__button__wrapper'><div class='sl-swell-event__article__image__button'><svg xmlns='http://www.w3.org/2000/svg' class='jw-svg-icon jw-svg-icon-fullscreen-on' viewBox='0 0 240 240' focusable='false'><path d='M96.3,186.1c1.9,1.9,1.3,4-1.4,4.4l-50.6,8.4c-1.8,0.5-3.7-0.6-4.2-2.4c-0.2-0.6-0.2-1.2,0-1.7l8.4-50.6c0.4-2.7,2.4-3.4,4.4-1.4l14.5,14.5l28.2-28.2l14.3,14.3l-28.2,28.2L96.3,186.1z M195.8,39.1l-50.6,8.4c-2.7,0.4-3.4,2.4-1.4,4.4l14.5,14.5l-28.2,28.2l14.3,14.3l28.2-28.2l14.5,14.5c1.9,1.9,4,1.3,4.4-1.4l8.4-50.6c0.5-1.8-0.6-3.6-2.4-4.2C197,39,196.4,39,195.8,39.1L195.8,39.1z'></path></svg></div></div>";
var getSkinPlayer = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(jwVideo, jwPlayer) {
        var embedURL, data, result, playerConfig, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(!(0,lodash.isNil)(jwVideo) && !(0,lodash.isNil)(jwPlayer))) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    embedURL = "https://cdn.jwplayer.com/players/".concat(jwVideo, "-").concat(jwPlayer, ".js");
                    return [
                        4,
                        (0,common_baseFetch/* doJSFetch */.dW)(embedURL)
                    ];
                case 2:
                    data = _state.sent();
                    result = data.substring(data.indexOf("var jwConfig = {"), data.indexOf("; // end config"));
                    playerConfig = JSON.parse(result.replace("var jwConfig = ", ""));
                    return [
                        2,
                        playerConfig || {}
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        {}
                    ];
                case 4:
                    return [
                        2,
                        {}
                    ];
            }
        });
    });
    return function getSkinPlayer(jwVideo, jwPlayer) {
        return _ref.apply(this, arguments);
    };
}();
var formatProductLinks = function() {
    var ref;
    var productLinks = (ref = (0,getWindow/* default */.Z)()) === null || ref === void 0 ? void 0 : ref.document.querySelectorAll("a[href^='".concat(config/* default.shopUrl */.Z.shopUrl, "']"));
    if (productLinks.length) {
        (0,_to_consumable_array/* default */.Z)(productLinks).map(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(productLink) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    // set referrer-policy to ensure full URL is passed to shop for event tracking
                    productLink.setAttribute("referrerpolicy", "no-referrer-when-downgrade");
                    // remove rel to ensure noreferrer is removed from link
                    productLink.removeAttribute("rel");
                    return [
                        2
                    ];
                });
            });
            return function(productLink) {
                return _ref.apply(this, arguments);
            };
        }());
    }
};
var renderIgElements = function() {
    var ref;
    var igElements = (ref = (0,getWindow/* default */.Z)()) === null || ref === void 0 ? void 0 : ref.document.querySelectorAll("[data-sl-ig]");
    if (igElements.length) {
        (0,_to_consumable_array/* default */.Z)(igElements).map(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(ig) {
                var ref, html;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,fetchOembed/* default */.Z)(ig.dataset.slIg, "/api/content/oembed")
                            ];
                        case 1:
                            ref = _state.sent(), html = ref.oembedObj.html;
                            external_ReactDOM_default().render(/*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                markup: html,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: html
                                    }
                                })
                            }), ig);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(ig) {
                return _ref.apply(this, arguments);
            };
        }());
    }
};
var renderJWElements = function() {
    var ref;
    var hasJwVideoStarted = false;
    var jwElements = (ref = (0,getWindow/* default */.Z)()) === null || ref === void 0 ? void 0 : ref.document.querySelectorAll("[id*='jw']");
    if (jwElements.length) {
        (0,_to_consumable_array/* default */.Z)(jwElements).map(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(jw) {
                var ref, ref1, jwId, jwPlayer, playerConfig, blogherads, manuallyStartVideoTimeout, player, manuallyStartVideo;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            ref1 = (0,_sliced_to_array/* default */.Z)(jw.id.split("_"), 3), jwId = ref1[1], jwPlayer = ref1[2];
                            return [
                                4,
                                getSkinPlayer(jwId, jwPlayer)
                            ];
                        case 1:
                            playerConfig = _state.sent();
                            if (((ref = (0,getWindow/* default */.Z)()) === null || ref === void 0 ? void 0 : ref.jwplayer) && jwId) {
                                if (config/* default.she.useSheMedia */.Z.she.useSheMedia) {
                                    blogherads = (0,getWindow/* default */.Z)().blogherads || {};
                                    blogherads.adq = blogherads.adq || [];
                                    blogherads.adq.push(function() {
                                        blogherads.setConf("vertical", "PreRoll_Article");
                                    });
                                }
                                ;
                                player = (0,getWindow/* default */.Z)().jwplayer(jw.id).setup((0,_object_spread/* default */.Z)({}, playerConfig));
                                manuallyStartVideo = function() {
                                    if (hasJwVideoStarted === false && playerConfig.advertising && player.getState() !== "playing") {
                                        delete playerConfig.advertising;
                                        player = (0,getWindow/* default */.Z)().jwplayer(jw.id).setup((0,_object_spread/* default */.Z)({}, playerConfig));
                                        player.play();
                                        hasJwVideoStarted = true;
                                    }
                                };
                                player.on("beforePlay", function() {
                                    manuallyStartVideoTimeout = setTimeout(manuallyStartVideo, 3000);
                                }).on("adBreakStart", function() {
                                    hasJwVideoStarted = true;
                                }).on("firstFrame", function() {
                                    hasJwVideoStarted = true;
                                }).on("remove", function() {
                                    clearTimeout(manuallyStartVideoTimeout);
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(jw) {
                return _ref.apply(this, arguments);
            };
        }());
    }
};
var unmountJWElements = function() {
    var ref;
    var jwElements = (ref = (0,getWindow/* default */.Z)()) === null || ref === void 0 ? void 0 : ref.document.querySelectorAll(".sl-jw-video-wrap");
    if (jwElements.length) {
        jwElements.forEach(function(_player, index) {
            (0,getWindow/* default */.Z)().jwplayer(index).remove();
        });
    }
};
var renderTwitterElements = function() {
    var twitterElements = win === null || win === void 0 ? void 0 : win.document.getElementsByClassName("twitter-tweet");
    if (twitterElements.length) {
        (0,_to_consumable_array/* default */.Z)(twitterElements).map(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(tweetElement) {
                var tweetUrl, ref, html;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            tweetUrl = tweetElement.getElementsByTagName("a")[1].href;
                            return [
                                4,
                                (0,fetchOembed/* default */.Z)(tweetUrl, "/api/content/oembed")
                            ];
                        case 1:
                            ref = _state.sent(), html = ref.oembedObj.html;
                            external_ReactDOM_default().render(/*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                markup: html,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: html
                                    }
                                })
                            }), tweetElement);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(tweetElement) {
                return _ref.apply(this, arguments);
            };
        }());
    }
};
var createCameraObject = function(cameraDetails) {
    return {
        streamUrl: cameraDetails.cam.streamUrl,
        stillUrl: cameraDetails.cam.stillUrl,
        status: {
            isDown: !!cameraDetails.cam.isDown.status,
            message: cameraDetails.cam.isDown.message,
            subMessage: cameraDetails.cam.isDown.subMessage
        },
        isPrerecorded: false,
        isPremium: cameraDetails.cam.isPremium,
        title: "title"
    };
};
/**
 * @param {boolean} isPremium
 */ var renderCameraEmbeds = function(isPremium) {
    var cameraEmbeds = win === null || win === void 0 ? void 0 : win.document.getElementsByClassName("wp-cam-embed");
    if (cameraEmbeds.length) {
        (0,_to_consumable_array/* default */.Z)(cameraEmbeds).map(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(embedElement) {
                var cameraId, detailsJson, spotReport, camera, camStillUrl, isPremiumCam, showPremiumCamPaywall, segmentProperties;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            cameraId = embedElement.getAttribute("data-sl-cam-id");
                            return [
                                4,
                                (0,cameras/* fetchCamEmbedDetails */.Px)(cameraId)
                            ];
                        case 1:
                            detailsJson = _state.sent();
                            return [
                                4,
                                (0,spot/* fetchReport */.OH)(detailsJson.spot.id)
                            ];
                        case 2:
                            spotReport = _state.sent();
                            camera = createCameraObject(detailsJson);
                            camStillUrl = camera.stillUrl;
                            isPremiumCam = camera.isPremium;
                            showPremiumCamPaywall = isPremiumCam && !isPremium;
                            segmentProperties = {
                                location: "premium only cam - cam embed",
                                title: "Premium Analysis",
                                category: "forecast",
                                spotId: detailsJson.spot.id,
                                spotName: detailsJson.spot.name
                            };
                            if (showPremiumCamPaywall) {
                                external_ReactDOM_default().render(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "video-wrap-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "video-wrap",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumCamCTA/* default */.Z, {
                                            camStillUrl: camStillUrl,
                                            href: "".concat(config/* default.surflineHost */.Z.surflineHost).concat(config/* default.funnelUrl */.Z.funnelUrl),
                                            onClickPaywall: function() {
                                                return (0,segment/* trackClickedSubscribeCTA */.$b)(segmentProperties);
                                            }
                                        })
                                    })
                                }), embedElement);
                            } else {
                                external_ReactDOM_default().render(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "video-wrap-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "video-wrap",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CamPlayer/* default */.Z, {
                                            aspectRatio: "16:9",
                                            adTag: {
                                                iu: "/1024858/SL_Editorial_Embed_PreRoll"
                                            },
                                            advertisingIds: spotReport.associated.advertising,
                                            playerId: cameraId || "sl-editorial-embed",
                                            camera: camera,
                                            spotName: detailsJson.spot.name,
                                            spotId: detailsJson.spot.id,
                                            isPremium: isPremium,
                                            isMultiCam: false,
                                            location: "Editorial Embed"
                                        })
                                    })
                                }), embedElement);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(embedElement) {
                return _ref.apply(this, arguments);
            };
        }());
    }
};
var renderYoutubeEmbeds = function() {
    var ref;
    var youtubeEmbedContainers = win === null || win === void 0 ? void 0 : (ref = win.document) === null || ref === void 0 ? void 0 : ref.querySelectorAll(".sl-swell-event__article-container .quiver-forecast-article-card__body > p");
    if (youtubeEmbedContainers.length) {
        youtubeEmbedContainers.forEach(function(container) {
            var youtubeIframe = container.querySelector('iframe[src^="https://www.youtube.com/embed/');
            if (youtubeIframe) {
                external_ReactDOM_default().render(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    itemScope: true,
                    itemType: "https://schema.org/VideoObject",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            position: "relative",
                            overflow: "hidden",
                            paddingBottom: "56.25%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            src: youtubeIframe.src,
                            width: "100%",
                            height: "100%",
                            title: "Youtube Video",
                            style: {
                                position: "absolute"
                            },
                            allowFullScreen: true
                        })
                    })
                }), container);
            }
        });
    }
};
var replaceWithClickableImage = function(onClick, getImages) {
    var imgElements = win === null || win === void 0 ? void 0 : win.document.querySelectorAll(".sl-swell-event__content__wrapper p > img, .wp-caption > img");
    var images = [];
    if (imgElements.length) {
        (0,_to_consumable_array/* default */.Z)(imgElements).map(function(img, index) {
            /* eslint-disable-next-line no-param-reassign */ img.onclick = function() {
                return onClick(index);
            };
            img.insertAdjacentHTML("afterend", swellEventArticleButton);
            images.push({
                src: img.src,
                w: img.clientWidth,
                h: img.clientHeight,
                index: index
            });
            return img;
        });
    }
    getImages(images);
    return null;
};
var renderFeaturedVideo = function(jwId) {
    var featuredVideoElements = win === null || win === void 0 ? void 0 : win.document.getElementsByClassName("sl-swell-event-featured-media");
    if (featuredVideoElements.length) {
        (0,_to_consumable_array/* default */.Z)(featuredVideoElements).map(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(jw) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    if (win && win.jwplayer && jwId) {
                        win.jwplayer(jw.id).setup({
                            playlist: "https://content.jwplatform.com/feeds/".concat(jwId, ".json"),
                            ph: 2
                        });
                    }
                    return [
                        2
                    ];
                });
            });
            return function(jw) {
                return _ref.apply(this, arguments);
            };
        }());
    }
};
var renderResizedImages = function() {
    var imgElements = win === null || win === void 0 ? void 0 : win.document.getElementsByTagName("img");
    if (imgElements.length) {
        (0,_to_consumable_array/* default */.Z)(imgElements).map(function(img) {
            if (img.src.indexOf("/wp-content/uploads") > -1) {
                /* eslint-disable-next-line no-param-reassign */ img.src = config/* default.cloudflareImageResizingUrl */.Z.cloudflareImageResizingUrl(img.src);
                return img;
            }
            return img;
        });
    }
};
var renderAd = function(element, adNumber, adIdentifier, dfpKeyword, qaFlag) {
    var ref;
    element.insertAdjacentHTML("afterend", '<div id="ad-'.concat(adNumber, '" />'));
    external_ReactDOM_default().render(/*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleDFP/* default */.Z, {
        adConfig: (0,adConfig/* default */.Z)(adIdentifier, [
            [
                "qaFlag",
                qaFlag
            ],
            [
                "contentKeyword",
                dfpKeyword
            ], 
        ]),
        isHtl: true,
        isTesting: config/* default.htl.isTesting */.Z.htl.isTesting,
        useSheMedia: config/* default.she.useSheMedia */.Z.she.useSheMedia
    }), (ref = (0,getWindow/* default */.Z)()) === null || ref === void 0 ? void 0 : ref.document.getElementById("ad-".concat(adNumber)));
};
var renderSurfNetworkVideo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var ref, surfNetworkContainerElement, videoId, surfNetworkToken;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    surfNetworkContainerElement = (ref = (0,getWindow/* default */.Z)()) === null || ref === void 0 ? void 0 : ref.document.getElementById("sl-surfnetwork-video");
                    if (!surfNetworkContainerElement) return [
                        3,
                        2
                    ];
                    videoId = surfNetworkContainerElement.getAttribute("data-sl-video-id");
                    if (!videoId) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,baseFetch/* doExternalFetch */.Ey)("/api/content/surfnetwork")
                    ];
                case 1:
                    surfNetworkToken = _state.sent();
                    external_ReactDOM_default().render(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        itemScope: true,
                        itemType: "https://schema.org/VideoObject",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                position: "relative",
                                overflow: "hidden",
                                paddingBottom: "56.25%"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                src: "https://api.nodplatform.com/partner/surfline/watch/".concat(videoId, ".html?access_token=").concat(surfNetworkToken),
                                width: "100%",
                                height: "100%",
                                title: "SurfNetwork",
                                style: {
                                    position: "absolute"
                                },
                                allowFullScreen: true
                            })
                        })
                    }), surfNetworkContainerElement);
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return function renderSurfNetworkVideo() {
        return _ref.apply(this, arguments);
    };
}();
var renderArticleAds = function(articleRef, children, dfpKeyword, createdAt, qaFlag) {
    var adTracker = {
        count: 0,
        placed: 0
    };
    children.forEach(function(node, index) {
        if (node.tagName === "P" || node.tagName === "IMG" || node.className.indexOf("video") > -1 || node.className.indexOf("img") > -1) {
            adTracker.count += 1;
        }
        if (adTracker.count === 4 && adTracker.placed < 3) {
            var adNumber = adTracker.placed + 1;
            var adIdentifier = adNumber === 1 && new Date(createdAt) < new Date("2019-04-29 00:00:00") ? "legacyEditContent" : "editBody".concat(adNumber);
            renderAd(articleRef.current.children[index], adNumber, adIdentifier, dfpKeyword, qaFlag);
            adTracker.count = -1;
            adTracker.placed += 1;
        } else if (index === children.length - 1 && adTracker.placed === 0) {
            var adNumber1 = adTracker.placed + 1;
            renderAd(articleRef.current.children[index], adNumber1, "editBody".concat(adNumber1), dfpKeyword, qaFlag);
        }
    });
};
var trackArticleLinkClicks = function(articleId) {
    var ref;
    var articleBody = (ref = (0,getWindow/* default */.Z)()) === null || ref === void 0 ? void 0 : ref.document.getElementById("sl-editorial-article-body");
    var articleLinks = articleBody.querySelectorAll("a");
    if (articleLinks.length) {
        (0,_to_consumable_array/* default */.Z)(articleLinks).map(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(ig, index) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    articleLinks[index].addEventListener("click", function(event) {
                        return (0,segment/* trackEvent */.L9)("Clicked Link", {
                            articleId: articleId,
                            category: "editorial",
                            linkLocation: "editorialContent",
                            linkName: event.target.innerText || articleLinks[index].innerText,
                            linkUrl: event.target.href || articleLinks[index].href
                        });
                    }, false);
                    return [
                        2
                    ];
                });
            });
            return function(ig, index) {
                return _ref.apply(this, arguments);
            };
        }());
    }
};
var renderVideoPaywalls = function(onClickVideoPaywall, onClickSignIn, shouldPaywall) {
    var ref, ref1;
    var videoPaywallElement = (ref = (0,getWindow/* default */.Z)()) === null || ref === void 0 ? void 0 : ref.document.getElementById("sl-premium-video-cta");
    var videoPaywallCaptionElements = (ref1 = (0,getWindow/* default */.Z)()) === null || ref1 === void 0 ? void 0 : ref1.document.getElementsByClassName("sl-premium-video-text");
    if (videoPaywallElement && shouldPaywall) {
        external_ReactDOM_default().render(/*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumVideoCTA_PremiumVideoCTA, {
            onClickVideoPaywall: onClickVideoPaywall,
            imageUrl: videoPaywallElement.getAttribute("data-image-url"),
            onClickSignIn: onClickSignIn,
            videoText: videoPaywallCaptionElements.length ? videoPaywallCaptionElements[0].innerHTML : ""
        }), videoPaywallElement);
    }
};
var onClickAddToCalendar = function(trackData) {
    (0,segment/* trackEvent */.L9)("Clicked Link", trackData);
};
var renderCalendarEvents = function(articleId) {
    var ref;
    var eventElements = (ref = (0,getWindow/* default */.Z)()) === null || ref === void 0 ? void 0 : ref.document.getElementsByClassName("cal-event");
    if (eventElements.length) {
        (0,_to_consumable_array/* default */.Z)(eventElements).map(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                var spotReport, _spot, spotName, _associated, spotUrl, startTime, endTime, eventObj, trackData, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                (0,spot/* fetchReport */.OH)(event.querySelector("#cal-event-spot").innerHTML)
                            ];
                        case 1:
                            spotReport = _state.sent();
                            _spot = spotReport.spot, spotName = _spot.name, _associated = spotReport.associated, spotUrl = _associated.href;
                            startTime = event.querySelector("#cal-event-start").innerHTML.toString();
                            endTime = event.querySelector("#cal-event-end").innerHTML.toString();
                            eventObj = {
                                title: "Surf ".concat(spotName),
                                description: "Check out the forecast for ".concat(spotName, " at ").concat(spotUrl),
                                location: spotName,
                                startTime: startTime,
                                endTime: endTime
                            };
                            trackData = {
                                articleId: articleId,
                                category: "editorial",
                                linkLocation: "editorialContent",
                                linkName: "Add to Calendar",
                                linkUrl: spotUrl
                            };
                            external_ReactDOM_default().render(/*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCalendar/* default */.Z, {
                                onClickAdd: function() {
                                    return onClickAddToCalendar(trackData);
                                },
                                event: eventObj
                            }), event);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            console.error(err);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(event) {
                return _ref.apply(this, arguments);
            };
        }());
    }
};
var renderCalendarCinemaEvents = function(articleId) {
    var ref;
    var eventElements = (ref = (0,getWindow/* default */.Z)()) === null || ref === void 0 ? void 0 : ref.document.getElementsByClassName("cal-event-cinema");
    if (eventElements.length) {
        (0,_to_consumable_array/* default */.Z)(eventElements).map(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                var startTime, endTime, description, title, link, eventObj, trackData;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    try {
                        startTime = event.querySelector("#cal-event-start").innerHTML.toString();
                        endTime = event.querySelector("#cal-event-end").innerHTML.toString();
                        description = event.querySelector("#cal-event-description").innerHTML.toString();
                        title = event.querySelector("#cal-event-title").innerHTML.toString();
                        link = event.querySelector("#cal-event-link").innerHTML.toString();
                        eventObj = {
                            title: title,
                            description: "".concat(description, "\n          ").concat(link),
                            startTime: startTime,
                            endTime: endTime
                        };
                        trackData = {
                            articleId: articleId,
                            category: "editorial",
                            linkLocation: "editorialContent",
                            linkName: "Add to Calendar",
                            linkUrl: link
                        };
                        external_ReactDOM_default().render(/*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCalendar/* default */.Z, {
                            onClickAdd: function() {
                                return onClickAddToCalendar(trackData);
                            },
                            event: eventObj
                        }), event);
                    } catch (err) {
                        console.error(err);
                    }
                    return [
                        2
                    ];
                });
            });
            return function(event) {
                return _ref.apply(this, arguments);
            };
        }());
    }
};
var ProductCarousel = function(param) {
    var endpoint = param.endpoint, title = param.title, subtitle = param.subtitle, carouselItem = param.carouselItem, backgroundColor = param.backgroundColor, ctaCopy = param.ctaCopy, ctaUrl = param.ctaUrl;
    var DEFAULT_TITLE = "Shop";
    var DEFAULT_SUBTITLE = "Surfline premium members save when they shop";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledEngineProvider/* default */.Z, {
        injectFirst: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeProvider/* default */.Z, {
            theme: esm/* default */.ZP,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CssBaseline/* default */.ZP, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sl-article-body-content-carousel",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCarousel/* default */.Z, {
                        callToActionButton: {
                            isDark: false,
                            isExternal: true,
                            isReferrer: true,
                            text: ctaCopy || "View All",
                            link: ctaUrl || config/* default.shopUrl */.Z.shopUrl,
                            startIcon: true
                        },
                        carouselItem: carouselItem,
                        colors: {
                            bg: backgroundColor || esm/* default.expressive.marineLayer */.ZP.expressive.marineLayer,
                            skeletonBg: esm/* default.palette.text.light */.ZP.palette.text.light,
                            skeletonItem: esm/* default.palette.text.extraLight */.ZP.palette.text.extraLight,
                            headerText: esm/* default.palette.text.brandSecondary */.ZP.palette.text.brandSecondary,
                            headerButton: esm/* default.palette.text.brandSecondary */.ZP.palette.text.brandSecondary,
                            noItemsText: esm/* default.palette.text.base */.ZP.palette.text.base
                        },
                        dataTransform: function(data) {
                            var ref;
                            return data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.products;
                        },
                        fetchConfig: {
                            endpoint: endpoint,
                            fetch: common_baseFetch/* default */.ZP
                        },
                        isProductCarousel: true,
                        itemAspectRatio: 1.32,
                        noItemsMessage: {
                            message: "Find surf essentials in the Surfline shop, with special offers for Premium members.",
                            ctaCopy: "Check it out",
                            ctaUrl: config/* default.shopUrl */.Z.shopUrl
                        },
                        numberOfitems: 4,
                        openCtaInNewTab: true,
                        screenConfig: {
                            small: 3,
                            mobile: 2,
                            medium: 4,
                            large: 4
                        },
                        showLogo: true,
                        showPageCount: false,
                        style: {
                            marginBottom: 0
                        },
                        subtitle: subtitle || DEFAULT_SUBTITLE,
                        title: title || DEFAULT_TITLE
                    })
                })
            ]
        })
    });
};
var renderProductCarousel = function(segmentProperties) {
    var ref;
    var productElements = (ref = (0,getWindow/* default */.Z)()) === null || ref === void 0 ? void 0 : ref.document.querySelectorAll("div[data-sl-product-carousel-product-ids]");
    if (productElements === null || productElements === void 0 ? void 0 : productElements.length) {
        try {
            (0,_to_consumable_array/* default */.Z)(productElements).map(function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(productElement) {
                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, productIds, carouselTitle, carouselSubtitle, ctaCopy, ctaUrl, ctaSuffix, backgroundColor, endpoint, carouselItem;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        productIds = (ref = productElement.attributes["data-sl-product-carousel-product-ids"]) === null || ref === void 0 ? void 0 : ref.value;
                        carouselTitle = (ref1 = productElement.attributes["data-sl-product-carousel-title"]) === null || ref1 === void 0 ? void 0 : ref1.value;
                        carouselSubtitle = (ref2 = productElement.attributes["data-sl-product-carousel-subtitle"]) === null || ref2 === void 0 ? void 0 : ref2.value;
                        ctaCopy = (ref3 = productElement.attributes["data-sl-product-carousel-cta-copy"]) === null || ref3 === void 0 ? void 0 : ref3.value;
                        ctaUrl = (ref4 = productElement.attributes["data-sl-product-carousel-cta-url"]) === null || ref4 === void 0 ? void 0 : ref4.value;
                        ctaSuffix = (ref5 = productElement.attributes["data-sl-product-carousel-cta-suffix"]) === null || ref5 === void 0 ? void 0 : ref5.value;
                        backgroundColor = (ref6 = productElement.attributes["data-sl-product-carousel-bg-color"]) === null || ref6 === void 0 ? void 0 : ref6.value;
                        endpoint = "/store/products?productIds=".concat(productIds);
                        carouselItem = function(itemData, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(components_ProductCard, {
                                data: (0,transformers/* productCardTransformer */.mR)(itemData, ctaSuffix),
                                trackCardClick: function() {
                                    var ref;
                                    (0,segment/* trackEvent */.L9)("Carousel Clicked", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, segmentProperties), {
                                        location: "shop module",
                                        positionNumber: index,
                                        productId: itemData === null || itemData === void 0 ? void 0 : itemData.id,
                                        productName: itemData === null || itemData === void 0 ? void 0 : itemData.name,
                                        brandName: itemData === null || itemData === void 0 ? void 0 : (ref = itemData.brand) === null || ref === void 0 ? void 0 : ref.name
                                    }));
                                }
                            });
                        };
                        external_ReactDOM_default().render(/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCarousel, {
                            title: carouselTitle,
                            subtitle: carouselSubtitle,
                            carouselItem: carouselItem,
                            endpoint: endpoint,
                            ctaCopy: ctaCopy,
                            ctaUrl: ctaUrl,
                            backgroundColor: backgroundColor
                        }), productElement);
                        return [
                            2
                        ];
                    });
                });
                return function(productElement) {
                    return _ref.apply(this, arguments);
                };
            }());
        } catch (err) {
            console.log("An error was recieved while replacing the article Product Carousel: ", err);
        }
    }
};
var TravelCardCarousel = function(param) {
    var endpoint = param.endpoint, subtitle = param.subtitle, title = param.title, carouselItem = param.carouselItem;
    var DEFAULT_TITLE = "Travel";
    var DEFAULT_SUBTITLE = "Thinking about a surf trip? You’ve got options.";
    var ref = (0,external_React_.useState)(0), supplierCount = ref[0], setSupplierCount = ref[1];
    var cardsToDisplay = (0,external_React_.useMemo)(function() {
        return supplierCount > 1 && supplierCount < 4 ? supplierCount : 3;
    }, [
        supplierCount
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledEngineProvider/* default */.Z, {
        injectFirst: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeProvider/* default */.Z, {
            theme: esm/* default */.ZP,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CssBaseline/* default */.ZP, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sl-article-body-content-carousel",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCarousel/* default */.Z, {
                        carouselItem: carouselItem,
                        colors: {
                            bg: "#3B8E9F",
                            skeletonBg: "#206977",
                            skeletonItem: "#1d7b8e",
                            headerText: "white",
                            headerButton: "white"
                        },
                        dataTransform: function(data) {
                            setSupplierCount(data === null || data === void 0 ? void 0 : data.suppliers.length);
                            return data === null || data === void 0 ? void 0 : data.suppliers;
                        },
                        fetchConfig: {
                            endpoint: endpoint,
                            fetch: common_baseFetch/* default */.ZP
                        },
                        itemAspectRatio: 1.1,
                        numberOfitems: cardsToDisplay,
                        screenConfig: {
                            small: 2,
                            mobile: 1,
                            medium: cardsToDisplay
                        },
                        showLogo: true,
                        showPageCount: true,
                        style: {
                            marginBottom: 0
                        },
                        subtitle: subtitle || DEFAULT_SUBTITLE,
                        title: title || DEFAULT_TITLE
                    })
                })
            ]
        })
    });
};
/**
 * @param segmentProperties
 * brand: 'sl',
 * location: '',
 * path: '',
 * positionNumber: '',
 * postCategories: '',
 * postId: article.id,
 * category: 'travel',
 * provider: 'Booking Layer',
 * referrer: '',
 * search: '',
 * travelSupplierId: '',
 * travelSupplierName: '',
 * travelZone: '',
 * title: displayTitle || title,
 * url: permalink,
 * */ var renderTravelCardCarousel = function(segmentProperties) {
    var ref;
    var travelElements = (ref = (0,getWindow/* default */.Z)()) === null || ref === void 0 ? void 0 : ref.document.querySelectorAll("div[data-sl-travel-carousel-supplier-ids]");
    if (travelElements.length) {
        try {
            (0,_to_consumable_array/* default */.Z)(travelElements).map(function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(travelElement) {
                    var ref, ref1, ref2, ref3, queryString, carouselTitle, carouselSubtitle, endpoint, carouselItem;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        queryString = (ref = travelElement.attributes["data-sl-travel-carousel-supplier-ids"]) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.split(",").map(function(supplier) {
                            return supplier.split("|");
                        }).map(function(paramArray, index) {
                            var prefix = "suppliers[".concat(index, "]");
                            var parameter = paramArray.map(function(param) {
                                if (param.includes(":")) {
                                    var split = (0,_to_consumable_array/* default */.Z)(param.split(":"));
                                    return "".concat(prefix, "[").concat(split[0], "]=").concat(split[1]);
                                }
                                return "".concat(prefix, "[id]=").concat(param);
                            }).join("&");
                            return parameter;
                        }).join("&");
                        carouselTitle = (ref2 = travelElement.attributes["data-sl-travel-carousel-title"]) === null || ref2 === void 0 ? void 0 : ref2.value;
                        carouselSubtitle = (ref3 = travelElement.attributes["data-sl-travel-carousel-subtitle"]) === null || ref3 === void 0 ? void 0 : ref3.value;
                        endpoint = "/travel/suppliers?".concat(queryString);
                        carouselItem = function(itemData, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ContentCarouselCard/* default */.Z, {
                                data: (0,transformers/* supplierCardTransformer */.w3)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, itemData), {
                                    link: "/travel/surf-camp/".concat(itemData === null || itemData === void 0 ? void 0 : itemData.slug)
                                })),
                                trackCardClick: function() {
                                    (0,segment/* trackEvent */.L9)("Carousel Clicked", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, segmentProperties), {
                                        location: "travel module",
                                        positionNumber: index,
                                        referrer: "",
                                        search: "",
                                        travelSupplierId: itemData === null || itemData === void 0 ? void 0 : itemData.id,
                                        travelSupplierName: itemData === null || itemData === void 0 ? void 0 : itemData.name,
                                        travelZone: itemData === null || itemData === void 0 ? void 0 : itemData.travel_zones[0]
                                    }));
                                }
                            });
                        };
                        external_ReactDOM_default().render(/*#__PURE__*/ (0,jsx_runtime.jsx)(TravelCardCarousel, {
                            title: carouselTitle,
                            subtitle: carouselSubtitle,
                            carouselItem: carouselItem,
                            endpoint: endpoint
                        }), travelElement);
                        return [
                            2
                        ];
                    });
                });
                return function(travelElement) {
                    return _ref.apply(this, arguments);
                };
            }());
        } catch (err) {
            console.log("An error was recieved while replacing the article Travel Module: ", err);
        }
    }
};


/***/ }),

/***/ 32450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ stripHTMLFromText; }
/* harmony export */ });
function stripHTMLFromText(text) {
    var ref;
    var regexForStripHTML = /(<([^>]+)>)/gi;
    var ref1;
    var stripContent = (ref1 = text === null || text === void 0 ? void 0 : (ref = text.replace) === null || ref === void 0 ? void 0 : ref.call(text, regexForStripHTML, "")) !== null && ref1 !== void 0 ? ref1 : text;
    return stripContent;
}


/***/ }),

/***/ 34144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ getSupplierIcon; }
/* harmony export */ });
/* harmony import */ var _components_Icons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56693);

var getSupplierIcon = function(iconType) {
    var ref;
    var supplierPackageType = (ref = iconType === null || iconType === void 0 ? void 0 : iconType.trim()) === null || ref === void 0 ? void 0 : ref.toLowerCase();
    switch(supplierPackageType){
        case "surf charter":
            return _components_Icons__WEBPACK_IMPORTED_MODULE_0__/* .CharterIcon */ .lh;
        case "bed & breakfast":
            return _components_Icons__WEBPACK_IMPORTED_MODULE_0__/* .BedAndBreakfastIcon */ .ex;
        case "surf camp":
            return _components_Icons__WEBPACK_IMPORTED_MODULE_0__/* .CampIcon */ .oM;
        default:
            return function() {
                return null;
            };
    }
};
var defaultExport = {
    getSupplierIcon: getSupplierIcon
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (defaultExport)));


/***/ }),

/***/ 23896:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardCarousel":"CardCarousel_cardCarousel__AH4qJ","cardCarouselPreviousWrap":"CardCarousel_cardCarouselPreviousWrap__fcJSe","cardCarouselNextWrap":"CardCarousel_cardCarouselNextWrap__iLdyY","cardCarouselPrevious":"CardCarousel_cardCarouselPrevious__gO1eI","cardCarouselNext":"CardCarousel_cardCarouselNext__Q4kea","cardCarouselIndicators":"CardCarousel_cardCarouselIndicators__N4weZ","cardCarouselIndicator":"CardCarousel_cardCarouselIndicator__mkE16","cardCarouselIndicatorActive":"CardCarousel_cardCarouselIndicatorActive__2fqSs"};

/***/ }),

/***/ 79410:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentCarouselCard":"ContentCarouselCard_contentCarouselCard__N2RvB","contentCarouselCardInner":"ContentCarouselCard_contentCarouselCardInner__wsOKC","cardContent":"ContentCarouselCard_cardContent__Hs7l1","cardLink":"ContentCarouselCard_cardLink__CZsFM","contentCarouselCardHeaderWrap":"ContentCarouselCard_contentCarouselCardHeaderWrap__ApOci","contentCarouselCardHeader":"ContentCarouselCard_contentCarouselCardHeader__ghmE0","contentCarouselCardTitle":"ContentCarouselCard_contentCarouselCardTitle__Jw5q7","contentCarouselCardSubtitleWrap":"ContentCarouselCard_contentCarouselCardSubtitleWrap__PqDsf","contentCarouselCardSubtitle":"ContentCarouselCard_contentCarouselCardSubtitle___dHrC","contentCarouselCardActions":"ContentCarouselCard_contentCarouselCardActions__di_Lg","cardPriceButton":"ContentCarouselCard_cardPriceButton__yoYIS","descriptionWrap":"ContentCarouselCard_descriptionWrap___GU45","supplierCard":"ContentCarouselCard_supplierCard__l0h9G"};

/***/ }),

/***/ 87229:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"ProductCard_card__HOfbL","cardInner":"ProductCard_cardInner__4R1z7","cardContent":"ProductCard_cardContent___HGWX","cardLink":"ProductCard_cardLink__HaRto","cardHeader":"ProductCard_cardHeader__bBL_J","cardCategory":"ProductCard_cardCategory__QgZVd","cardTitle":"ProductCard_cardTitle__g0Fx8","cardActions":"ProductCard_cardActions__Uffep"};

/***/ })

}]);